import { PreferencesResponse } from '../../../@types/preferences';
import type { PreferenceUpdateBody } from '../../../@types/preferences';
import type { ReactNode } from 'react';
import { VideaTypography } from '../../../common-components/elements/VideaTypography/VideaTypography';
import { Switch } from '@repo/videa-components/src/ui/switch';
import { Label } from '@repo/videa-components/src/ui/label';
import { RadioGroup } from '@repo/videa-components/src/ui/radio-group';

export const PracticePreferencesRadioGroup = (props: {
  switchLabel: string;
  preferenceKey: keyof PreferencesResponse;
  defaultValue: number;
  label: string;
  preferences: PreferencesResponse;
  preferencesUpdate: (update: PreferenceUpdateBody) => void;
  children: ReactNode;
}) => {
  return (
    <>
      <div
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
          flexWrap: 'nowrap',
          gap: '.5em',
          maxWidth: '30em',
        }}
      >
        <Switch
          defaultChecked={props.preferences[props.preferenceKey] !== 0}
          checked={props.preferences[props.preferenceKey] !== 0}
          onCheckedChange={(checked) => {
            props.preferencesUpdate({
              [props.preferenceKey]: checked ? props.defaultValue : 0,
            } as any);
          }}
        />

        <VideaTypography variant="labelSmall">
          {props.switchLabel}
        </VideaTypography>
      </div>
      {props.preferences[props.preferenceKey] !== 0 && (
        <div>
          <Label className="!vai-text-base">
            {props.label}
          </Label>
          <RadioGroup
            className="pref-control-group vai-mt-1"
            value={String(
              props.preferences[props.preferenceKey] ?? props.defaultValue,
            )}
            onValueChange={(value) => {
              props.preferencesUpdate({
                [props.preferenceKey]: Number(value),
              });
            }}
          >
            <div className="vai-flex vai-flex-row vai-gap-4">
              {props.children}
            </div>
          </RadioGroup>
        </div>
      )}
    </>
  );
};
